import React from 'react';
import { Button } from '../../components/Button';
interface Product {
  name: string;
  price: string;
  image: string;
  href?: string;
  hasConfigurator?: boolean;
  badge?: string;
}
const products: Product[] = [
// Gen 3
{
  name: 'Gen3-PSS-Gloves USAT',
  price: '$69.00',
  image: 'https://cdn.magicpatterns.com/uploads/niYhHZHhKrMG2frXtC3Vmj/Gen3_PSS-Gloves_USAT.png',
  hasConfigurator: true,
  href: '/m5/EPRO%2029943--Official-Daedo-Gen3-Gloves.html',
  badge: 'New'
}, {
  name: 'Gen3 E-Foot Gear',
  price: '$110.84',
  image: 'https://cdn.magicpatterns.com/uploads/cViGkDXcDmPVipYt9uyQmt/Gen3_E-Foot_Gear.jpg',
  hasConfigurator: true,
  href: '/m5/EPRO%2029039--gen3-e-foot-gear.html',
  badge: 'New'
}, {
  name: 'Gen3 Transmitter TK-Strike (Head)',
  price: '$556.85',
  image: 'https://cdn.magicpatterns.com/uploads/32CSZRc127TCj3au4ThHui/GEN3_TRANSMITTER_TK-STRIKE_(HEAD).webp',
  hasConfigurator: true,
  href: '/m5/EPRO%2029902-U-0--gen3-e-head-transmitter-tk-strike-head.html'
}, {
  name: 'Gen3 Transmitter TK-Strike (Body)',
  price: '$459.35',
  image: 'https://cdn.magicpatterns.com/uploads/1ih3djYezzVq8985HX8oSL/GEN3_TRANSMITTER_TK-STRIKE_(BODY).webp',
  hasConfigurator: true,
  href: '/m5/EPRO%2029901-U-0--gen3-transmitter-tk-strike-body.html'
}, {
  name: 'TK-Strike Gen3 Receiver',
  price: '$688.34',
  image: 'https://cdn.magicpatterns.com/uploads/55DtFd96dsvi8vp6TjTcGE/TK-STRIKE_GEN3_RECEIVER.webp',
  hasConfigurator: true,
  href: '/m5/EPRO%2029926-U-0--tk-strike-gen3-receiver.html'
}, {
  name: 'Gen3 Electronic Body Protector',
  price: '$847.22',
  image: 'https://cdn.magicpatterns.com/uploads/nf6K7oc2o7k9Lq2qdDp2cD/Red-GEN3_ELECTRONIC_BODY_PROTECTOR.webp',
  hasConfigurator: true,
  href: '/m5/EPRO%202990--gen3-e-hogus.html'
}, {
  name: 'Gen3 E-Head Gear',
  price: '$399.99',
  image: 'https://cdn.magicpatterns.com/uploads/pZymF2e8PGGmiMTnD1QNCR/Red-and-BlueGEN3_E-HEAD_GEAR.webp',
  hasConfigurator: true,
  href: '/m5/EPRO%2029913--gen3-e-head-gear.html'
}, {
  name: 'Gen 3 Software Download',
  price: '$99.99',
  image: 'https://cdn.magicpatterns.com/uploads/uzhJjiwifSbakuQBq1HFz4/Gen3_Software_download.png',
  href: '/m5/EPRO%2029907-U-0--gen3-software-download.html'
},
// Daedo PSS
{
  name: 'Gen2 Transmitter Charger',
  price: '$55.00',
  image: 'https://cdn.magicpatterns.com/uploads/qEV6XsHhowYMSa1F9qrPwc/Gen2_Transmitter_Charger.jpg'
}, {
  name: 'Gen2 W.T. Software',
  price: '$99.00',
  image: 'https://cdn.magicpatterns.com/uploads/orVwRQoYnnfYKgyRtLXkKq/Gen2_W.T._Software.jpg'
}, {
  name: 'Gen2 Judge Box (Refurbished)',
  price: '$580.00',
  image: 'https://cdn.magicpatterns.com/uploads/bS347spy52LoYXHH7zr4qL/Gen2_Judge_Box_(Refurbished)_Same_Warranty.jpg'
}, {
  name: 'Gen2 Receiver',
  price: '$390.00',
  image: 'https://cdn.magicpatterns.com/uploads/w3Q65FCerZEu2ek6y4Xdyo/Gen2_Receiver.jpg'
}, {
  name: 'Gen2 E-HeadGear',
  price: '$399.00',
  image: 'https://cdn.magicpatterns.com/uploads/oEDj2ZvCJJBgsVECUR8bR3/Gen2_E-HeadGear.jpg',
  hasConfigurator: true
}, {
  name: 'Gen2 Head Transmitter',
  price: '$390.00',
  image: 'https://cdn.magicpatterns.com/uploads/keKg2f8ApxK9KnFdbJLkPa/Gen2_Head_Transmitter.jpg'
},
// Daedo
{
  name: 'Gen2 E-Chest Gear Adult Size',
  price: '$775.00',
  image: 'https://cdn.magicpatterns.com/uploads/kfguP8tNDqA8zXYkxoyPcg/Gen2_E-Chest_Gear_Adult_Size.jpg',
  hasConfigurator: true,
  href: '/E-Chest-Gear-Adult'
}, {
  name: 'Gen2 E-Foot Gear',
  price: '$95.00',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FDaedo%2FGeneration2%2Fepro29037_1_optimizacionweb.jpg',
  hasConfigurator: true
}, {
  name: 'Daedo Truescore E-Foot Gear Magnet Tester',
  price: '$9.99',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2Fdaedo-e-footgear-magnet-tester.jpg'
},
// Wacoku
{
  name: 'Wacoku Intro Colored Belt Uniform',
  price: '$37.00',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FRedesign%2FWacokuIntro.jpg',
  hasConfigurator: true
}, {
  name: 'Wacoku WTF/WT Lightweight Uniform',
  price: '$75.00',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FWTF%20AT210B.jpg800x800.jpg',
  hasConfigurator: true
}, {
  name: 'Wacoku WTF/WT Reversible Chest Gear',
  price: '$70.00',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FWTF%20B132W-1.jpg800x800.jpg',
  hasConfigurator: true
}, {
  name: 'Wacoku WTF/WT Headgear',
  price: '$49.99',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FWTF%20I201.jpg800x800.jpg',
  hasConfigurator: true
}];
/**
 * Shop All Products grid — every product across categories.
 */
export function ProductGrid() {
  return <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-809">
      {products.map((product, index) => {
      const href = product.href ?? '#';
      return <article key={`${product.name}-${index}`} className="group flex flex-col bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-md transition-shadow" data-id="element-810">
            <a href={href} className="block relative aspect-square bg-gray-50 overflow-hidden" data-id="element-811">
              {product.badge && <span className="absolute top-3 left-3 bg-red-600 text-white text-[10px] font-bold uppercase tracking-wide px-2 py-1 rounded" data-id="element-812">
                  {product.badge}
                </span>}
              {product.image.startsWith('http') ? <img src={product.image} alt={product.name} className="block w-full h-full object-contain p-4 group-hover:scale-105 transition-transform duration-300" data-id="element-813" /> : <div className="w-full h-full flex items-center justify-center text-xs text-gray-400 text-center px-4" data-id="element-814">
                  Product Image
                </div>}
            </a>

            <div className="flex flex-col flex-grow p-5" data-id="element-815">
              <a href={href} className="flex-grow" data-id="element-816">
                <h3 className="text-base font-bold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors line-clamp-2 min-h-[3rem]" data-id="element-817">
                  {product.name}
                </h3>
              </a>
              <div className="mb-4" data-id="element-818">
                <p className="text-xl font-black text-gray-900" data-id="element-819">
                  {product.price}
                </p>
              </div>
              {product.hasConfigurator ? <Button href={href} variant="primary" className="w-full !py-2 text-sm mt-auto" data-id="element-820">
                  Select Options
                </Button> : <Button href={href} variant="primary" className="w-full !py-2 text-sm bg-red-600 hover:bg-red-700 focus:ring-red-600 mt-auto" data-id="element-821">
                  Add To Cart
                </Button>}
            </div>
          </article>;
    })}
    </div>;
}